<template>
  <b-row>
    <b-col cols="12">
      <shift-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ShiftAddForm from './ShiftAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    ShiftAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
